import { useEffect, useState } from "react"
import { useApi } from "../../context/ApiProvider";

export default function ExportOwners() {

  const [paying, setPaying] = useState(1);
  const [owners, setOwners] = useState(false);
  const [blob, setBlob] = useState(false);
  const [url, setUrl] = useState(false);

  const Api = useApi();
  
  useEffect(() => {
    if(!owners) {
      return;
    }
    prepareExport();
  }, [owners]);

  const prepareExport = () => {
    let fileData = "Company:;First name:;Last name:;Email:\r\n"

    for(let owner of owners) {
      if(owner.included == 1) {
        fileData += `${owner.company};${owner.firstName};${owner.lastName};${owner.email}\r\n`;
      }
    }

    const blob = new Blob([ new Uint8Array([0xEF, 0xBB, 0xBF]), fileData], { type: "text/csv;charset=utf-8" });
    let url = URL.createObjectURL(blob);

    setBlob(blob);
    setUrl(url);
  }


  const fetchOwners = async () => {
    Api.get(`/rolf/exportowners?paying=${paying}`).then(data => {
      
      data = data.map((obj) => { return {...obj, included: 1}})
      setOwners(data);
    }).catch(e => {
      console.log(e)
    })
  }

  //Ändra så vi inte använder Index
  const toggleInclude = (id) => {
    let toggledArr = owners.map((owner) => {
      if(owner.ID == id) {
        owner.included == 1 ? owner.included = 0 : owner.included = 1;
      }
      return owner;
    })

    setOwners([...toggledArr]);
  }

  const DisplayOwners = (props) => {

    const toggleInclude = props.toggleInclude;
    const theOwners = props.owners;

    return(
      <table>
        <thead>
          <tr>
            <th>Company:</th>
            <th>First name:</th>
            <th>Last name:</th>
            <th>E-mail:</th>
            <th>Include:</th>
          </tr>
        </thead>
        <tbody>
        {
          theOwners.length > 0 && theOwners.map((owner, index) => {
            return (
              <tr key={index}>
                <td>{owner.company}</td>
                <td>{owner.firstName}</td>
                <td>{owner.lastName}</td>
                <td>{owner.email}</td>
                <td><input type="checkbox" onChange={() => { toggleInclude(owner.ID); }}  checked={owner.included}/></td>
              </tr>
            )
          })
        }
        </tbody>
      </table>);
    
  }

  return (
    <div className="grid-container">
      <section>
        <h4>Export groupleaders</h4>
        <p>Export all groupleaders with their email addresses.</p>
        <label className="formControl">
          <input type="radio" name="paying" checked={paying} onChange={e => setPaying(1)} />
          Only paying clients
        </label>
        <label className="formControl">
          <input type="radio" name="paying" checked={!paying} onChange={e => setPaying(0)} />
          Include all clients
        </label>
        <input type="button" value="Fetch groupleaders" onClick={() => {fetchOwners()}}/>

        {
          blob &&  url && <a href={url} target="_blank" style={{marginLeft: 16}}><button>Export selected to CSV (Excel)</button></a>
        }

       
        

        <DisplayOwners owners={owners} toggleInclude={toggleInclude}/>
      </section>
    </div>

  )
}